import { render, staticRenderFns } from "./bulk.vue?vue&type=template&id=6414a11b&scoped=true"
import script from "./bulk.vue?vue&type=script&lang=ts"
export * from "./bulk.vue?vue&type=script&lang=ts"
import style0 from "./bulk.vue?vue&type=style&index=0&id=6414a11b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6414a11b",
  null
  
)

export default component.exports